import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import WithNavigation from '../../layouts/WithNavigation';
import Heading from '../../components/Heading';
import Tabs from '../../components/Tabs';
import KeyContactsTable from '../../components/KeyContactsTable';
import { fetchKeyContacts, clearKeyContacts } from '../../store/actions/keyContacts';
import { setSearch } from '../../store/actions/search';
import { selectCurrentUserSuite } from '../../store/selectors/userSuites';
import { selectKeyContacts } from '../../store/selectors/KeyContacts';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';


class KeyContacts extends Component {
    componentDidMount(){
        const { onFetchKeyContacts, currentUserSuite, clearKeyContacts } = this.props;
        clearKeyContacts();
        if(currentUserSuite && currentUserSuite.propertyId) {
          onFetchKeyContacts(currentUserSuite.propertyId);  
        }            
    }

    render() {
        const { keyContacts, setSearch } = this.props;  
        
        return (
           <>
           {
            this.props.loader?<Loader center={true}/>:null
           }
           <WithNavigation
                title='Key Contacts'
                top={(
                    <Heading
                        headline="Key Contacts"
                        items={[
                            {
                                key: 'Key Contacts',
                                value: keyContacts.length
                            }

                        ]}
                    />
                )}
                bottom={
                    (
                        <Tabs
                            items={[
                                {
                                    label: 'Key Contacts',
                                    // length: 1,
                                    content: (
                                        <KeyContactsTable
                                            keyContacts={keyContacts}
                                            onSearch={e => setSearch({ keyContacts: e.target.value.trim() })}
                                        />
                                    )
                                }
                            ]}
                        />
                    )
                }
            />
           </>
        )
    }
}
const mapStateToProps = state => ({
    keyContacts: selectKeyContacts(state),
    currentUserSuite: selectCurrentUserSuite(state),
    loader:selectPRLoader(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({
    onFetchKeyContacts: fetchKeyContacts,
    clearKeyContacts: clearKeyContacts,
    setSearch

},dispatch)


export default connect(mapStateToProps,mapDispatchToProps)(KeyContacts);